<template>
  <div>
        <div class="content">
            <div class="content e_container">
            <input type="hidden" value="" id="sessionid" />
            <input type="hidden" value="" id="sig" />
            <input type="hidden" value="" id="token" />
                <!-- <div style="font-size: 20px;color: #00182c;margin-bottom:15px;">精工制造</div> -->
                <table class="model_table pack">
                    <thead>
                        <tr>
                            <th style="height:35px" >类别</th>
                            <th style="height:35px">数据与功能</th>                   
                            <th width="270"  style="height:35px">9C套餐 - 量化交易</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td rowspan="8" width="160">标配数据</td>
                            <td>中国金融期货交易所*<sup style="position: relative; left: -2px">1</sup></td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td>上海期货交易所（含上期能源）</td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td>大连商品交易所</td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td>郑州商品交易所</td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td>广州期货交易所</td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td>上海证券交易所*<sup style="position: relative; left: -2px">1</sup></td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td>深圳证券交易所*<sup style="position: relative; left: -2px">1</sup></td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td>文华商品指数和系列板块指数</td>
                            <td>√</td>
                        </tr>
                            <tr>
                            <td rowspan="11">趋势策略方面</td>
                            <td>公式编写</td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td>基本面函数</td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td><a href="https://wt9.wenhua.com.cn/Solution/index?flag=0&tab=2" target="_blank">专业回测报告</a></td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td>枚举法参数优化<img src="../assets/img/huo2.gif" width="23" height="23" style="vertical-align:middle;"></td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td>遗传算法参数优化</td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td><a href="https://wt9.wenhua.com.cn/Solution/index?flag=3&tab=0" target="_blank">多模型组合配置</a></td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td><a href="https://wt9.wenhua.com.cn/Solution/index?flag=0&tab=1" target="_blank">期货主连链回测</a><img src="../assets/img/huo2.gif" width="23" height="23" style="vertical-align:middle;"></td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td>期货多因子分析<img src="../assets/img/huo2.gif" width="23" height="23" style="vertical-align:middle;"></td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td><a href="https://wt9.wenhua.com.cn/Solution/index?flag=5&tab=0" target="_blank">期货合约运行模组</a></td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td><a href="https://wt9.wenhua.com.cn/Solution/index?flag=4&tab=0" target="_blank">产品申购/赎回管理</a><img src="../assets/img/huo2.gif" width="23" height="23" style="vertical-align:middle;"></td>
                            <td>√</td>
                        </tr>
                        <!-- <tr>
                            <td>股票账号T+0交易池</td>
                            <td>√</td>
                        </tr> -->
                        <tr>
                            <td>日志邮件发送</td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td rowspan="7"> 盘口算法模型方面</td>
                            <td><a href="https://wt9.wenhua.com.cn/Solution/index?flag=0&tab=0" target="_blank">历史tick行情数据</a></td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td>盘口算法模型编写</td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td>自定义函数编写</td>
                            <td>√</td>
                        </tr>

                        <tr>
                            <td>虚拟撮合部分成交<img src="../assets/img/huo2.gif" width="23" height="23" style="vertical-align:middle;"></td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td><a href="https://wt9.wenhua.com.cn/Solution/index?flag=1&tab=0" target="_blank">盘口算法模型回测</a><img src="../assets/img/huo2.gif" width="23" height="23" style="vertical-align:middle;"></td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td>专业回测报告</td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td><a href="https://wt9.wenhua.com.cn/Solution/index?flag=2&tab=0" target="_blank">算法交易模型运行池</a><img src="../assets/img/huo2.gif" width="23" height="23" style="vertical-align:middle;"></td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td rowspan="2">其他</td>
                            <td>云端止损单</td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td>账户风控</td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td rowspan="3">售后服务</td>
                            <td>专属的金融工程师</td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td>辅助编写模型</td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td>文文通即时服务</td>
                            <td>√</td>
                        </tr>
                        <tr>
                            <td colspan="2"  rowspan="2" style="text-align: center;padding: 5px 8px;">
                                以上打勾功能服务费<br />
                                
                            </td>
                            <td style="text-align:left;padding:15px 11px">
                                <div style="width:213px;text-align:right;color: #287cee;">
                                    <span style="line-height:22px;">{{webMarketPrice.monthprice}}</span>&nbsp;元/月/账号<s @click="showiframe(1)" style="cursor:pointer;text-decoration: underline;margin-left:10px">去购买</s><br>
                                    <span style="line-height:22px;">{{webMarketPrice.quarterprice}}</span>&nbsp;元/季/账号<s @click="showiframe(2)" style="cursor:pointer;text-decoration: underline;margin-left:10px">去购买</s><br>
                                    <span style="line-height:22px">{{webMarketPrice.price1}}</span>&nbsp;元/年/账号<s @click="showiframe(3)" style="cursor:pointer;text-decoration: underline;margin-left:10px">去购买</s><br>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td style="padding:10px 0 10px 12px;text-align:left;color:#287cee;">机构本地部署：<br> <p style="padding:1px 0 0 28px;margin-bottom:-18px;color: #287cee;"><span>6</span>万元/年+<span>N</span>×<span>{{webMarketPrice.price1}}</span>元/年</p><br style="height:10px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;对接盛立、艾科朗克等高频系统的行情和交易接口</td>
                        </tr>
                    </tbody>
                </table>
                <!-- <div class="bmodel kongb1" style="width:868px"></div> -->
                <div class="bmodel pbyBtn" style="width:868px;border:none;background:none;margin-left:-25px;">
                    <!-- <p class="care" style="margin: 10px 0 0 30px;font-size: 16px;">*注：</p> -->
                    <p class="care" style="font-size: 14px;">*注：中国金融期货数据及国内股票数据仅限在中国大陆范围内查看使用；</p>
                    <!-- <p class="care" style="font-size: 14px;">4.如需在境外查看中金一档数据，需付数据使用费。</p> -->
                    
                </div>
                <!-- <div class="bmodel kongb1" style="width:868px"></div> -->
                <div class="bmodel pbyBtn" style="border:1px dashed #a0a0a0;background:#fffeec">
                    <p class="care" style="font-size: 14px;margin: 10px 0 0 30px;margin-left:5px;"><img src="https://www.wenhua.com.cn/static/images/tanhao1.png" style="margin: 0 5px 0 0;">声明</p>
                    <p class="care" style="font-size: 14px;margin-left:5px;">1.按照监管新规，新客户必须报备通过以后才能程序化交易，请先向期货公司报备，再购买软件;</p>
                    <p class="care" style="font-size: 14px;margin-left:18px;margin-top: -5px;">登录软件后，在菜单 量化－>程序化报备，也可向部分期货公司报备。</p>
                    <p class="care" style="font-size: 14px;margin-left:5px;">2.服务期内我司有权对其他数据、信息、功能进行增减等调整;</p>
                    <p class="care" style="font-size: 14px;margin-left:5px;">
                        3.你可能遇到的下列情形（包括但不限于）恕我司不负责解决，并不退还剩余费用：<br />
                        （1）因电脑硬件配置低或操作系统版本过低，无法满足新版要求；<br />
                        （2）开户的期货公司，不再支持星格软件。
                    </p>
                </div>
                <div class="bmodel pbyBtn" style="border: none;height: 100px;background: none;margin-bottom: -42px;padding: 10px 0 25px 0;">
                    <div style="position: absolute;left:0;top:56px;font-size:14px;" class="buy_tel">咨询电话：<common-data name="serviceTel"/></div>
                    
                </div>
            </div>
        </div>
        <Pay v-if="showpay" :src="src" @close="close"></Pay>
  </div>
</template>

<script setup>
import axios from 'axios'
import {ref,onMounted} from 'vue'
import Pay from './Pay.vue'
const showpay = ref(false)
const src =ref('')
const webMarketPrice=ref({
        price1:0,
        monthprice:0,
        quarterprice:0,
      })
const setPrice=function(){
      axios.get('https://pay.wenhua.com.cn/api/Product/Detail?id=124').then((res) => {
          if (res.data.status) {
            webMarketPrice.value.price1 = res.data.data.price
            webMarketPrice.value.monthprice = res.data.data.monthprice
            webMarketPrice.value.quarterprice = res.data.data.quarterprice
          } else {
            alert(res.data.message)
          }
        });
}
setPrice()
const showiframe = function(num){
  if(!!num){
    src.value='https://pay.wenhua.com.cn/#/iframePay/124?from=starquant&paytype='+num
  }
  showpay.value=true
}
const close = function(message){
  if(message.data=='close'){
    showpay.value = false
  }
}
</script>

<style scoped>
    html,body{
        font-size:12px !important;
    }
    .model_table{
        border-collapse: collapse;
        font-size: 14px;
        line-height: 20px;
        width: 715px;
    }
    .model_table thead tr {
        background: url(../assets/img/table_title.png)no-repeat center;
        background-size: 100% 100%; 
    }
    .model_table.pack{
        text-align: center;
    }

    .model_table th{
        border: 1px solid white;
        vertical-align: middle;
    }
    .model_table td{
        border: 1px solid #cccccc;
        vertical-align: middle;
    }

    .model_table th{
        height: 84px;
        font-size: 16px;
        color: #fff;
        text-align:center;
    }

    .model_table td{
        padding: 5px 8px;
    }

    .model_table td a{
        /* border-bottom: 1px solid  #333; */
        color: #737373;
        text-decoration: none;
    }
    .model_table td a:hover{
        color: blue;
        border-bottom: 1px solid  blue;
        text-decoration: none;
    }
    .model_table td span{
        font-weight: 700;
        font-size: 20px;
        line-height: 30px;
    }

    .model_table.pack td:nth-last-child(2){
        text-align: left;
    }

    /* .model_table.pack td:nth-last-child(2),
    .model_table.pack td:nth-last-child(2) span{
        background: #faf6f8;
        color: #960f03;
    } */

    .model_table.pack td:nth-last-child(1),
    .model_table.pack td:nth-last-child(1) span{
        /* background: #f5f5f9;
        color: #0b026f; */
    }

    .model_table.pack td:nth-last-child(2){
        padding-left: 8px;
    }

    .model_table.table2 td:nth-last-child(1){
        padding-left: 8px;
        /* background: #f5f5f9; */
    }
    .model_table.table2 td:nth-last-child(2){
        padding-left: 8px;
    }

    .cjwt{
        position: absolute;
        color: #004db6;
        font-size: 14px;
        top: 56px;
        right: 0px;
    }
    .care_a{
        color:blue;
        text-decoration:underline;
        cursor:pointer;
        position:relative;
        display:inline-block;
    }
    .care_a1{
        color:blue;
        text-decoration:underline;
        cursor:pointer;
        position:relative;
        display:inline-block;
    }
    .order_jys_a{
        display:block;
        margin-left:119px;
        font-size:14px;
        padding:5px 0;
    }
    a.order_jys_a{
        color:blue;
    }
    .sqzl .warp {
    width: 100%;
    height: 100%;
}

.sqzl .content {
    width: 700px;
    height: 590px;
    margin: 0 auto;

    background: #ffffff;
    border: 1px solid #94b5dc;
    /* box-shadow: #666 0px 0px 20px 5px; */
}

.sqzl .content .test1 {
    padding-top: 38px;
    font-size: 15px;
    color: #656565;
}

.sqzl .content h2 {
    display: block;
    height: 47px;
    line-height: 47px;
    text-align: center;
    width: 100%;
    font-size: 17px;
    font-weight: 700;
    color: #012f6d;
    background: #d8e5f8;
    position: relative;
}

.closeYY {
    position: absolute;
    width: 16px;
    height: 15px;
    background: url(../assets/img/close_01.png) no-repeat;
    right: 24px;
    top: 14px;
    cursor: pointer;
    z-index:66666
}

.sqzl .table19 {
    clear: both;
    margin: 0 auto;
}

.sqzl .denote {
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    padding-top:15px;
    padding-bottom:8px;
    text-align:left;
    color:#707070;
    padding-left:105px;
}

.sqzl .mask {
    width: 100%;
    height: 100%;
    position: absolute;
    background: rgba(0, 0, 0, 0.3);
    left: 0;
    top: 0;
    z-index: -1;
}

.sqzl .table19 .place {
    height: 23px;
}

.sqzl .note-td0 {
    text-align: right;
    color: #436291;
    font-weight: 800;
    font-size: 14px;
    padding-right: 10px;
}


/* .sqzl .note-td0:after {
    content: "*";
    color: red;
    vertical-align: bottom;
    font-size: 14px;
    line-height: 14px;
    padding-right: 5px;
    display: inline-block;
    *display: inline;
    zoom: 1;
    width: 7px;
} */

.sqzl .note-td0.zhongji::after {
    font-size: 0;
}

.sqzl .inp {
    width: 350px;
    height: 35px;
    border: none;
    padding-left: 10px;
    font-size: 15px;
    background: #f7f7f7;
}

.sqzl .amp {
    display: inline-block;
    overflow: hidden;
    border: 1px solid #c6c6c6;
}

.sqzl .select {
    width: 159px;
    height: 35px;
    display: inline-block;
    text-align: left;
    background: #f7f7f7;
    cursor: pointer;
    padding-left: 10px;
}

.sqzl .select span {
    font-size: 15px;
    line-height: 35px;
    margin-left: 6px;
    color: #757575;
}

.sqzl .select s {
    display: inline-block;
    float: right;
    margin-top: 14.5px;
    margin-right: 2px;
    width: 20px;
    height: 10px;
    overflow: hidden;
    background: url(../assets/img/arrbot.png) no-repeat center bottom;
}

.sqzl .group {
    display: inline-block;
    position: relative;
}

.sqzl .list {
    width: 169px;
    background: #fff;
    border: 1px solid #ccc;
    border-top: none;
    max-height: 202px;
    overflow-y: auto;
    overflow-x: hidden;
    position: absolute;
    top: 35px;
    left: 0;
    z-index: 1;
}

.sqzl .list li {
    height: 35px;
    text-align: center;
    line-height: 35px;
    cursor: pointer;
    font-size: 16px;
    color: #737373;
}

.sqzl .list li span:hover {
    color: #fff;
    background: #0F5EA3;
}

.sqzl .list li span {
    display: inline-block;
    width: 215px;
    height: 100%;
    padding-left: 10px;
    text-align: left;
}

.sqzl .list.none {
    display: none;
}

.sqzl .left_place {
    height: 42px;
    background: transparent;
}

.sqzl .note-td1 {
    background: transparent;
}

.sqzl .note-td1 div {
    width: 90px;
    height: 35px;
    background: #012f6d;
    color: #fff;
    font-size: 17px;
    text-align: center;
    line-height: 35px;
    cursor: pointer;
    margin: 0 auto;
    margin-top: 36px;
}

.sqzl #layer_wrap {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 0;
    z-index: 1;
}

.sqzl .layer {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto auto;
    width: 372px;
    height: 164px;
    background: #fff;
    border: 1px solid #ccc;
}

.sqzl .layer .tit {
    width: 372px;
    height: 24px;
    background: #0F5EA3;
}

.sqzl .layer .tit .x {
    width: 17px;
    height: 15px;
    float: right;
    background: url(../assets/img/x-1.jpg)no-repeat;
    margin-right: 10px;
    margin-top: 4.5px;
    cursor: pointer;
}

.sqzl .layer p {
    margin-top: 25px;
    margin-left: 66px;
    font-size: 18px;
    display: inline-block;
    line-height: 29px;
    font-size: 600;
}

.sqzl .layer p:before {
    content: url(../assets/img/x.jpg);
    vertical-align: middle;
    width: 24px;
    height: 24px;
    display: inline-block;
    padding-right: 18px;

}

.sqzl .layer_content {
    width: 100%;
    margin-top: 30px;
    margin-left: 95px;
    font-size: 14px;
    color: #a9a9a9;
}

.layer .dh span {
    color: #00182c;
    font-weight: normal;
}

.sqzl .layer .dh:before {
    content: url(../assets/img/dh.jpg);
    vertical-align: middle;
    width: 24px;
    height: 24px;
    display: inline-block;
    padding-right: 8px;

}

.sqzl .layer .none:before {
    content: none;
}

.sqzl .bottom {
    margin: 0;
}
#layer_wrap {
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.3);
        position: fixed;
        top: 0;
        z-index: 9999;
    }
    .layer {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto auto;
        width: 372px;
        height: 164px;
        background: #fff;
        border: 1px solid #ccc;
    }
    .layer .tit {
    	width: 372px;
    	height: 24px;
    	background: #0F5EA3;
    }
    .layer .tit .x {
    	width:17px;
    	height: 15px;
    	float: right;
    	background: url(../assets/img/x-1.jpg)no-repeat;
    	margin-right: 10px;
    	margin-top: 4.5px;
        cursor: pointer;
    }
    .layer p {
		margin-top: 25px;
		margin-left: 66px;
        padding: 0 30px;
		height: 24px;
		font-size: 18px;
		display: inline-block;
		line-height: 24px;
		font-weight: 600;
		color: #545454;
        position: relative;
    }
    .layer p:before {
		content:url(../assets/img/x.jpg);
        width: 24px;
        height: 24px;
        position: absolute;
        left: 0;
        top: 0;
    }
    .layer_content {
        /* width: 100%; */
        padding-right:20px;
        margin-top: 9px;
        margin-left: 98px;
        font-size: 14px;
		color: #828282;
    }
    /* .layer .dh {
		margin: 38px 32px;
    } */
    .layer .dh span {
		display: inline-block;
    }
    .layer .dh span.dh_span {
		display: inline-block;
		padding-left: 36px;
    }
    .layer .dh:before {
		content:url(../assets/img/dh.jpg);
        vertical-align: middle;
        width: 24px;
        height: 24px;
        display: inline-block;
        padding-right:12px;
    }
    .layer .none:before {
		content: none;
    }
    .order_yzm{
        margin-left:20px;
        border:1px solid #c6c6c6;
        height:100%;
        display:inline-block;
        width:105px;
        vertical-align: top;
        line-height: 35px;
        text-align: center;
        cursor:pointer;
        font-size: 15px;
        background: #f7f7f7;
        color:#757575;
        position:relative;
        overflow:hidden;
    }
    #sc{
        margin:0;
        position:absolute;
        top: -4px;
        right: 0;
        width: 365px;
        opacity:0;
        background:white;
    }
    .order_photo{
        height:40px;
        width:40px;
        font-size:33px;
        line-height:38px;
        text-align:center;
        display:inline-block;
        border:1px solid #cbcbcb;
        font-weight: 100;
        color:#cbcbcb;
        cursor:pointer;
        user-select: none;
        position:relative;
    }
    .order_photo_tap{
        display:inline-block;
    }
    .order_photo_input{
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
        opacity: 0;
        cursor:pointer;
        font-size:0;
        z-index:44;
    }
    .care {
    font-size: 13px;
    color: #737373;
    margin-left: 30px;
    line-height: 23px;
}
.pbyBtn {
    width: 714px;
    border-bottom: 1px solid #a0a0a0;
    border-right: 1px solid #a0a0a0;
    border-top: 0;
    position: relative;
    background: #f9f5e0;
    padding-bottom: 15px;
    padding-top: 8px;
}
.rnowBuy {
    display: block;
    position: absolute;
    top: 30px;
    right: 0px;
    width: 140px;
    height: 43px;
    /* border: 1px solid #fc8d1f; */
    border-radius: 5px;
    color: #fc8d1f;
    /* font-size: 20px; */
    /* font-weight: bold; */
    text-align: center;
    line-height: 43px;
    text-decoration: none;
    background: #fefefe;
}

</style>